export const FEED_PERMISSION_RECEIVED = "FEED_PERMISSION_RECEIVED";
